import { render } from "./AdmitPatient.vue?vue&type=template&id=24d243a8&scoped=true"
import script from "./AdmitPatient.vue?vue&type=script&lang=js"
export * from "./AdmitPatient.vue?vue&type=script&lang=js"

import "./AdmitPatient.vue?vue&type=style&index=0&id=24d243a8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24d243a8"]])

export default __exports__